import { UNAUTH_USER, AUTH_USER, AUTH_ERROR } from './types';

import { AuthenticationService } from '../services';

export function authError(error) {
  return {
    type: AUTH_ERROR,
    payload: error
  };
}

export function signinUser({ username, password }) {
  return (dispatch) => {
    AuthenticationService.authenticate(username, password, null).then((response) => {
      localStorage.setItem('token', response.data.token);
      dispatch({ type: AUTH_USER });
    }).catch(error => {
      localStorage.removeItem('token');
      if (!error?.response && error?.message) {
        dispatch(authError(error?.message));
      } else {
        dispatch(authError("bad login info"));
      }
      console.error(`signinUser exception: ${error?.message}`)
    });
  };
}

export function signinUserWithToken(token) {
  return (dispatch) => {
    setTimeout(() => {
      localStorage.setItem('token', token);
      dispatch({ type: AUTH_USER });
    }, 100);
  };
}

export function signinUserError(error, username) {
  return (dispatch) => {
      localStorage.removeItem('token');
      if (!error?.response && error?.message) {
        dispatch(authError(error?.message));
      } else {
        dispatch(authError("bad login info"));
      }
      console.error(`signinUserError exception: username=${username ? username : 'unknown'}, error=${error?.message}`);
  };
}

export function signoutUser() {
  AuthenticationService.logout().finally((_) => {
    console.log('Logout complete.');
    localStorage.removeItem("token");
  });
  return {
    type: UNAUTH_USER
  };
}

export function dispatchAuthUser() {
  return (dispatch) => {
    dispatch({ type: AUTH_USER });
  };
}